export const tryJSONParse = (json: string) => {
  let obj;

  try {
    obj = JSON.parse(json);
    // eslint-disable-next-line no-empty
  } catch {}

  return obj ?? null;
};

export const downloadJSON = (obj: object, filename = 'data.json') => {
  const jsonStr = JSON.stringify(obj, null, 2);
  const blob = new Blob([jsonStr], { type: 'application/json' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();

  URL.revokeObjectURL(url);
};
